__turbopack_context__.v({
  "afb__author": "rPgXNa_afb__author",
  "afb__title": "rPgXNa_afb__title",
  "deals-dlp": "rPgXNa_deals-dlp",
  "deals-dlp-salePrice": "rPgXNa_deals-dlp-salePrice",
  "deals-sale": "rPgXNa_deals-sale",
  "deals_page__dollar_sign": "rPgXNa_deals_page__dollar_sign",
  "dealspage__book": "rPgXNa_dealspage__book",
  "dealspage__book__on-sale-now": "rPgXNa_dealspage__book__on-sale-now",
  "dealspage__book_detail": "rPgXNa_dealspage__book_detail",
  "dealspage__bookcontent": "rPgXNa_dealspage__bookcontent",
  "dealspage__saleprice_text": "rPgXNa_dealspage__saleprice_text",
  "dealspage_book_read_more_link": "rPgXNa_dealspage_book_read_more_link",
  "sale_price": "rPgXNa_sale_price",
});
